import { compact, filter, get, sortBy } from 'lodash';
import { VISIBLE } from '../constants';
import { MetadataOption, AttributeMetadata } from '../MetadataAttribute';

export interface AttributeData {
    name?: string;
    options?: MetadataOption[];
    metadata?: AttributeMetadata;
}

export const validateAttributes = (metadataAttributes: AttributeData[]): AttributeData[] =>
    filter(compact(metadataAttributes), (attribute) => get(attribute, 'metadata.visibility', VISIBLE) === VISIBLE);

export const sortAttributes = (metadataAttributes: AttributeData[]): AttributeData[] =>
    sortBy(metadataAttributes, (attribute) => get(attribute, 'metadata.order', 0));
